<mat-dialog-content>
  <h1>Schedule Hours Override</h1>
  <div class="close-modal" (click)="onNoClick()">X</div>
  <mat-stepper linear #stepper>
    <mat-step [stepControl]="hoursOverrideForm" [editable]="true">
      <form [formGroup]="hoursOverrideForm">
        <ng-template matStepLabel>Hours Override Information</ng-template>
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Date for Hours Override</mat-label>
            <input matInput [matDatepicker]="dp" formControlName="date" />
            <mat-hint>MM/DD/YYYY</mat-hint>
            @if (hoursOverrideForm.value.date) {
              <button matSuffix type="button" (click)="clearDate()" aria-label="Clear date" class="clear-date-button">
                <span>✕</span>
              </button>
            }
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill">
            <mat-label>Open</mat-label>
            <mat-select formControlName="openIndex">
              @if (hoursOverrideForm.value.openIndex !== "") {
                <mat-option [value]="''">-- Clear Selection --</mat-option>
              }
              @for (time of timeRange; track time) {
                <mat-option [value]="time.index">
                  {{ time.time | timeOnly }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Close</mat-label>
            <mat-select formControlName="closeIndex">
              @if (hoursOverrideForm.value.closeIndex !== "") {
                <mat-option [value]="''">-- Clear Selection --</mat-option>
              }
              @for (time of timeRange; track time) {
                <mat-option [value]="time.index">
                  {{ time.time | timeOnly }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <mat-checkbox formControlName="closedForDay">Closed for day</mat-checkbox>
        <br />
        <br />

        <h3>Additional Options</h3>
        <div style="margin-bottom: 1em">
          <div style="font-weight: 500">Edits:</div>
          @if (changedFields.length === 0) {
            <div style="color: #888">No changes yet.</div>
          }
          @for (edit of changedFields; track edit) {
            <div style="color: #444">
              {{ edit }}
            </div>
          }
        </div>
        <mat-checkbox formControlName="isMultiPrep">Apply this to more Prep Locations</mat-checkbox><br />
        <mat-checkbox formControlName="isMultiStore">Apply this to more stores</mat-checkbox>

        <div class="button-container">
          <button mat-flat-button class="cancel-button" color="secondary" (click)="onNoClick()">Cancel</button>

          @if (isMultiAny()) {
            <button
              mat-button
              matStepperNext
              mat-raised-button
              class="save-button"
              color="accent"
              [disabled]="hoursOverrideForm.invalid || !isFormValid">
              Continue
            </button>
          }

          @if (!isMultiAny()) {
            <button
              mat-raised-button
              class="save-button"
              color="accent"
              [disabled]="hoursOverrideForm.invalid || !isFormValid"
              (click)="saveHoursOverride()">
              Save
            </button>
          }
        </div>
      </form>
    </mat-step>
    @if (hoursOverrideForm.value.isMultiPrep) {
      <mat-step [stepControl]="multiPrepForm" [editable]="true">
        <form [formGroup]="multiPrepForm">
          <ng-template matStepLabel>Select Prep Locations</ng-template>
          <multi-prep-checklist
            [(prepLocations)]="prepLocations"
            [currentPrepLocation]="prepLocationTypeName"
            (validationCheck)="prepLocationValidation()"></multi-prep-checklist>
          @if (multiPrepForm.controls["prepLocations"].invalid) {
            <div class="alert alert-danger">
              @if (multiPrepForm.controls["prepLocations"].errors) {
                <div>A Prep Location needs to be selected.</div>
              }
            </div>
          }
          <div class="button-container">
            <button mat-button matStepperPrevious type="button">Back</button>
            @if (hoursOverrideForm.value.isMultiStore) {
              <button
                mat-button
                matStepperNext
                mat-raised-button
                class="save-button"
                color="accent"
                [disabled]="multiPrepForm.invalid">
                Continue
              </button>
            }
            @if (!hoursOverrideForm.value.isMultiStore) {
              <button
                mat-raised-button
                class="save-button"
                color="accent"
                [disabled]="multiPrepForm.invalid || hoursOverrideForm.invalid || !isFormValid"
                (click)="saveHoursOverride()">
                Save
              </button>
            }
          </div>
        </form>
      </mat-step>
    }
    @if (hoursOverrideForm.value.isMultiStore) {
      <mat-step [stepControl]="multiStoreForm" [editable]="true">
        <form [formGroup]="multiStoreForm">
          <ng-template matStepLabel>Select Stores</ng-template>
          <multi-store-dropdown
            [(facilities)]="facilities"
            [currentFacilityId]="currentFacilityId"
            (validationCheck)="facilityValidation()"></multi-store-dropdown>
          @if (multiStoreForm.controls["facilities"].invalid) {
            <div class="alert alert-danger">
              @if (multiStoreForm.controls["facilities"].errors) {
                <div>A Facility needs to be selected.</div>
              }
            </div>
          }
          <div class="button-container">
            <button mat-button matStepperPrevious type="button">Back</button>
            <button
              mat-raised-button
              class="save-button"
              color="accent"
              [disabled]="multiStoreForm.invalid || hoursOverrideForm.invalid || !isFormValid"
              (click)="saveHoursOverride()">
              Save
            </button>
          </div>
        </form>
      </mat-step>
    }
  </mat-stepper>
</mat-dialog-content>
